import axios from 'axios';

// Production API URL (hardcoded fallback)
const PRODUCTION_API_URL = 'https://portfolioallocationapp-production.up.railway.app/api';

// Determine API URL based on environment (same logic as api.js)
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  const hostname = window.location.hostname;

  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8000/api';
  }

  // Local network testing (mobile on same WiFi)
  if (/^192\.168\.|^10\.|^172\.(1[6-9]|2[0-9]|3[01])\./.test(hostname)) {
    return `http://${hostname}:8000/api`;
  }

  // Production fallback
  return PRODUCTION_API_URL;
};

const API_BASE_URL = getApiBaseUrl();

const authAxios = axios.create({
  baseURL: `${API_BASE_URL}/auth`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
authAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('sessionToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Auth API methods
export const authApi = {
  // Sign up new user
  signup: async (email, password, name) => {
    const response = await authAxios.post('/signup', { email, password, name });
    return response.data;
  },

  // Login with email/password
  login: async (email, password) => {
    const response = await authAxios.post('/login', { email, password });
    return response.data;
  },

  // Verify OTP code
  verifyOTP: async (email, otpCode, otpType = 'verification') => {
    const response = await authAxios.post('/verify-otp', {
      email,
      otp_code: otpCode,
      otp_type: otpType,
    });
    return response.data;
  },

  // Resend OTP
  resendOTP: async (email, otpType = 'verification') => {
    const response = await authAxios.post('/resend-otp', {
      email,
      otp_type: otpType,
    });
    return response.data;
  },

  // Logout
  logout: async () => {
    const response = await authAxios.post('/logout');
    localStorage.removeItem('sessionToken');
    localStorage.removeItem('user');
    return response.data;
  },

  // Get current user
  getCurrentUser: async () => {
    const response = await authAxios.get('/me');
    return response.data;
  },

  // Validate session
  validateSession: async () => {
    const response = await authAxios.get('/validate-session');
    return response.data;
  },
};

// Helper to save session
export const saveSession = (sessionToken, user) => {
  localStorage.setItem('sessionToken', sessionToken);
  localStorage.setItem('user', JSON.stringify(user));
};

// Helper to get stored user
export const getStoredUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

// Helper to check if logged in
export const isLoggedIn = () => {
  return !!localStorage.getItem('sessionToken');
};

export default authApi;
